module.exports = function(h, row) {
    return moment(row.transaction_date).format('MMM Do YYYY, h:mm:ss a');
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/audit_trail/columns/transaction_date.jsx